<div class="flex-row column border-radius-16 align-center"
    [class]="data.availableRewards.length ? 'bg-white': 'bg-secondary'">
    <ng-container *ngIf="!isLoggedIn">
        <div class="flex-row column align-center row-gap-20 p-24">
            <img class="max-width-md-11" src="assets/new-assets/reward-logo.svg" alt="Total reward">
            <p class="text-dark fs-32 fw-9 lh-32">{{this.totalReward | currency:'INR':'symbol'}}</p>
            <p class="text-center max-width-23 fw-6 lh-24">You will receive a cashback of {{this.totalReward |
                currency:'INR':'symbol'}} in your UPI</p>
            <ul class="flex-row column text-secondary align-center fs-md-14 row-gap-10">
                <ng-container *ngFor="let item of data.availableRewards;">
                    <li>{{item.tittle}} - {{item?.amount |currency:'INR':'symbol'}}</li>
                </ng-container>
            </ul>
            <button type="button" class="btn btn-primary width-32 full-md" (click)="closeDialog()">Okay, got
                it!</button>
        </div>
    </ng-container>
    <ng-container *ngIf="isLoggedIn">
        <ng-container *ngIf="data.availableRewards.length">
            <ng-container *ngIf="currentReward">
                <div
                    class="p-24 flex-row align-center column-gap-15 text-start fs-md-14  color-secondary bg-color-95c4d033 full">
                    <tick-icon bgColor="#01AE45" borderColor="#01AE45" tickColor="white" [widthHeight]="32"></tick-icon>
                    <p> You have received a cashback of {{currentReward.amount | currency:'INR':'symbol'}} for
                        <ng-container
                            *ngIf="currentReward.rewardConfiguration.activity === 'referral_credits_rfd'">signing
                            up.</ng-container>
                        <ng-container
                            *ngIf="currentReward.rewardConfiguration.activity === 'risk_profile_update_rfd'">risk
                            profile completion.</ng-container>
                        <ng-container
                            *ngIf="currentReward.rewardConfiguration.activity === 'free_pack_subscription_rfd'">free
                            investpack subscription.</ng-container>
                        <ng-container
                            *ngIf="currentReward.rewardConfiguration.activity === 'paid_pack_subscription_rfd'">paid
                            investpack subscription.</ng-container>
                        <ng-container
                            *ngIf="currentReward.rewardConfiguration.activity === 'first_time_investment_rfd'">first
                            time investment.</ng-container>
                        Claim it in the rewards section.
                    </p>
                </div>
            </ng-container>
            <div class="flex-row column align-center row-gap-25 p-24 full">
                <img class="max-width-md-11" src="assets/new-assets/reward-logo.svg" alt="Total reward">
                <p class="text-dark fs-32 fw-9 lh-32">{{this.totalReward | currency:'INR':'symbol'}}</p>
                <p class="text-center max-width-23 text-dark fw-6">You can get a cashback of {{totalReward |
                    currency:'INR':'symbol'}}
                    <span *ngIf="currentReward"> more</span> in your UPI -
                </p>
                <ul class="flex-row column row-gap-8 mb-25 color-secondary">
                    <ng-container *ngFor="let item of data.availableRewards">
                        <li *ngIf="item.activity === 'risk_profile_update_rfd'">Complete your Risk Profile -
                            {{item?.amount | currency:'INR':'symbol'}}</li>
                        <li *ngIf="item.activity === 'free_pack_subscription_rfd'">Subscribe to a free Investpack -
                            {{item?.amount | currency:'INR':'symbol'}}</li>
                        <li *ngIf="item.activity === 'paid_pack_subscription_rfd'">Subscribe to a paid Investpack -
                            {{item?.amount | currency:'INR':'symbol'}}</li>
                        <li *ngIf="item.activity === 'first_time_investment_rfd'">After your first Investment -
                            {{item?.amount | currency:'INR':'symbol'}}</li>
                    </ng-container>
                </ul>
                <button type="button" class="btn btn-primary width-32 full-md" (click)="goTo('next')">Get
                    Started</button>
            </div>
        </ng-container>
        <ng-container *ngIf="currentReward && !data.availableRewards.length">
            <div class="flex-row column align-center row-gap-20 p-24 full">
                <img class="max-width-md-11" src="assets/new-assets/reward-logo.svg" alt="Unloack reward">
                <p class="text-center max-width-23 fs-18 fs-md-16 fw-8">You have unlocked a cashback reward of
                    {{currentReward.amount | currency:'INR':'symbol'}}</p>
                <p class="fw-5 text-secondary">You will get the cashback in your UPI id</p>
                <input class="bg-white border-radius-8 pt-10 pb-10 pl-15 border-color-8ABECB width-32 full-md"
                    specialChar [formControl]="name" placeholder="Enter your name" aria-label="Enter your name"
                    *ngIf="!currentUser.name && !currentUser.isEditVpa">
                <input class="bg-white border-radius-8 pt-10 pb-10 pl-15 border-color-8ABECB width-32 full-md"
                    [formControl]="vpa" placeholder="Enter your UPI id" aria-label="Enter your UPI id">
                <button type="button" class="btn btn-primary width-32 full-md" [disabled]="name.invalid || vpa.invalid"
                    (click)="claimReward(currentReward?._id)">Claim Reward</button>
                <button type="button" class="btn btn-outline border-none p-0" (click)="closeDialog()">Maybe
                    Later</button>
            </div>
        </ng-container>
        <ng-container *ngIf="data.page === 'noReward'">
            <div class="flex-row column align-center row-gap-20 p-24">
                <p class="fw-7 text-dark lh-24 text-center">Sadly, the referral code you have used is valid only for new
                    signups</p>
                <button type="button" class="btn btn-primary width-32 full-md" (click)="closeDialog()">Okay, got
                    it!</button>
            </div>
        </ng-container>
    </ng-container>
</div>